import React, { lazy } from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import TopActions from './TopActions';

const layout = window?.$environment?.CURRENT_LAYOUT;

const Label = lazy(() => import(`globalcomponents/UI/Label/${layout}`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} />
    </Box>
  );
};

const Component = ({
  notInUseVehicles,
  filterSuccess,
  Styled,
  i18n,
  topAction,
  pagination,
  setPagination,
}) => {
  const columns = [
    {
      id: 'unit_id',
      label: i18n.t('vehicles.unitId'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'driversCount',
      label: i18n.t('vehicles.drivers'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'type',
      label: i18n.t('vehicles.type'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'vin',
      label: i18n.t('vehicles.vin'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'year',
      label: i18n.t('vehicles.year'),
      numeric: true,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'manufact',
      label: i18n.t('vehicles.manufacturer'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
    {
      id: 'model',
      label: i18n.t('vehicles.model'),
      numeric: false,
      disablePadding: false,
      needSorting: true,
    },
  ];

  const generateRows = () => notInUseVehicles?.notInUseVehiclesFilteredList || [];

  const emptyMessage = i18n.t('common.tableEmptyMessage');

  return (
    <>
      <Styled.Wrapper>
        {topAction && (
          <TopActions
            filterSuccess={filterSuccess}
            Styled={Styled}
            i18n={i18n}
            notInUseVehicles={notInUseVehicles}
            setPagination={setPagination}
          />
        )}
        <Styled.TableWrapper>
          <Styled.LabelWrap>
            <Label className="logsInfoDisplay">
              {i18n.t('dashboard.notInUseVehicles.listHeading.INSHOP')}
            </Label>
          </Styled.LabelWrap>
          <Table
            type="client"
            title=""
            columns={columns}
            data={generateRows()}
            emptyMessage={emptyMessage}
            actions={[]}
            defaultSortBy={{ sortBy: 'unit_id', order: 'asc' }}
            itemsPerPage={10}
            i18n={i18n}
            paginationReset={pagination}
            paginationClicked={(e) => setPagination(!e)}
          />
        </Styled.TableWrapper>
      </Styled.Wrapper>
    </>
  );
};

Component.propTypes = {
  notInUseVehicles: PropTypes.object.isRequired,
  filterSuccess: PropTypes.func.isRequired,
  Styled: PropTypes.object.isRequired,
  i18n: PropTypes.object.isRequired,
  topAction: PropTypes.bool,
  pagination: PropTypes.bool.isRequired,
  setPagination: PropTypes.func.isRequired,
};

export default Index;